// extracted by mini-css-extract-plugin
export var component = "AlphabeticalPostsModule-module--component--pTyFN";
export var inner = "AlphabeticalPostsModule-module--inner--M7Iy7";
export var item = "AlphabeticalPostsModule-module--item--Ow2EX";
export var letter = "AlphabeticalPostsModule-module--letter--TG7ci";
export var link = "AlphabeticalPostsModule-module--link--qKoO-";
export var list = "AlphabeticalPostsModule-module--list--lwl3P";
export var section = "AlphabeticalPostsModule-module--section--GtuPb";
export var sections = "AlphabeticalPostsModule-module--sections--IXv9Q";
export var title = "AlphabeticalPostsModule-module--title--oax1y";